export function DeclineWaitlistEntries(organizationID: number, formID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/event-groups/waitlist/decline`;
}

export function Events(organizationID: number, formID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/event-groups/${ID}/events`;
}

export function InviteFirstFromWaitlist(organizationID: number, formID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/event-groups/${ID}/waitlist/invite-first`;
}

export function InviteFromWaitlist(organizationID: number, formID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/event-groups/waitlist/invite`;
}

export function Overview(organizationID: number, formID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/event-groups/${ID}/overview`;
}

export function Participants(organizationID: number, formID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/event-groups/${ID}/participants`;
}

export function RemoveParticipant(organizationID: number, formID: number, ID: number, submissionID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/event-groups/${ID}/participants/${submissionID}`;
}

export function RemoveWaitlistEntries(organizationID: number, formID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/event-groups/waitlist/remove`;
}

export function RevokeWaitlistInvites(organizationID: number, formID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/event-groups/waitlist/revoke`;
}

export function Schedule(organizationID: number, formID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/event-groups/${ID}/schedule`;
}

export function Upsert(organizationID: number, formID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/event-groups`;
}

export function Waitlist(organizationID: number, formID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/forms/${formID}/event-groups/${ID}/waitlist`;
}

